import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { WifiOff } from 'lucide-react';

/**
 * Stato della connessione.
 *
 * Onesta' del dato (brief §41/§46): quando siamo offline lo diciamo, invece di
 * mostrare dati vecchi come se fossero freschi. `role="status"` con
 * `aria-live="polite"` per l'annuncio agli screen reader.
 */
export function OfflineBanner(): ReactNode {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    const goOnline = (): void => {
      setOnline(true);
    };
    const goOffline = (): void => {
      setOnline(false);
    };
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="safe-top sticky top-0 z-30 flex items-center justify-center gap-2 bg-[var(--budget-warn-soft)] px-4 py-2 text-[13.5px] text-[var(--budget-warn)]"
    >
      <WifiOff size={16} aria-hidden="true" />
      <span>Sei offline — vedi gli ultimi dati salvati</span>
    </div>
  );
}
